import { Base } from "./base";

export class Endereco extends Base {
  public address?: any;
  public logradouro?: string;
  public enderecoCompleto?: string;
  public numero?: string;
  public bairro?: string;
  public complemento?: string;
  public municipio?: string;
  public estado?: string;
  public pais?: string;
  public latitude: number;
  public longitude: number;
  public apelidoEndereco?: string;
  public cep?: string;
  public referencia?: string;

  constructor() {
    super();
    this.latitude = 0;
    this.longitude = 0;
  }

  get coords(): number[] {
    return [this.longitude, this.latitude];
  }
}
